module.exports = __webpack_public_path__ + "static/media/ic_destination.c4d7889a.svg";